import { css } from 'lit';

export const IxLabelTagStyles = css`
  :host {
    display: inline-block;
  }

  :host([hidden]) {
    display: none;
  }

  :host(.new) {
    --md-theme-primary: rgb(76, 175, 80);
    --md-label-padding: 0.25rem 0.75rem;
  }

  :host(.active) {
    --md-theme-primary: var(--ix-sys-primary);
  }

  .label-tag {
    display: inline-block;
    padding: var(--ix-label-padding, 0.5rem 1rem);
    border-radius: var(--ix-border-radius, 2em);
    color: var(--ix-label-color, var(--clr-on-primary, #fff));
    background-color: var(--ix-label-bg-color, var(--clr-primary, #6200ee));
    font-size: var(--ix-label-font-size, var(--text-small-size, 0.75rem));
    line-height: var(
      --ix-label-line-height,
      var(--text-small-line-height, 1.5)
    );
    font-weight: var(--ix-label-font-weight, var(--text-small-weight, 500));
    letter-spacing: var(
      --ix-label-letter-spacing,
      var(--text-small-letter-spacing, 0.0892857143em)
    );
    text-decoration: var(
      --ix-label-text-decoration,
      var(--text-small-decoration, none)
    );
    text-transform: var(
      --ix-label-text-transform,
      var(--text-small-transform, none)
    );
  }
`;
